import {MODAL_TYPE_ALERT, MODAL_TYPE_CONFIRM} from "@/constants";

export default container => {
    container.declare("modal", ({Vue, store}) => ({
        dialog(message) {
            return new Promise((resolve, reject) => {
                this.show(message, MODAL_TYPE_CONFIRM);

                this.events.$on("modal-confirm", confirm => {
                    resolve(confirm);
                });
            });
        },
        show(message, type = MODAL_TYPE_ALERT) {
            store.service.send.call(store.service, `SHOW_MODAL`, [message, type]);
        },
        hide() {
            store.service.send.call(store.service, `HIDE_MODAL`);
        },

        events: new Vue(),
    }));
};
